export const PASSWORD_CHANGE_CODE = 4601;
export const PASSWORD_CHANGE_EVENT = 'password-change-required';
export const PASSWORD_CHANGE_PATH = '/password-change';
export const AUTH_SESSION_EXPIRED_EVENT = 'auth-session-expired';

export function normalizeUserInfo(data = {}) {
    const hasAdminRole = data.roleList?.some(role => String(role.id) === '1001') ||
        data.roleIds?.some(id => String(id) === '1001');
    return {
        phone: data.phone,
        role: hasAdminRole || data.roleType === 'admin' ? 'admin' : 'user',
        passwordChangeRequired: data.passwordChangeRequired === true,
        passwordChangeReason: data.passwordChangeReason || ''
    };
}

export function isPasswordChangeResponse(response) {
    return Number(response?.code) === PASSWORD_CHANGE_CODE;
}

export function isSessionExpiredResponse(response) {
    return Number(response?.code) === 401 || Number(response?.code) === 408 ||
        response?.msg === '登录超时,请重新登录';
}

export async function parseJsonBlobResponse(response) {
    const contentType = response?.headers?.['content-type'] || response?.data?.type || '';
    if (!(response?.data instanceof Blob) || !contentType.toLowerCase().includes('json')) return response;
    try {
        return { ...response, data: JSON.parse(await response.data.text()) };
    } catch (error) {
        return response;
    }
}

export function shouldRejectPasswordChangeResponse(response) {
    return response?.config?.responseType === 'blob' && isPasswordChangeResponse(response.data);
}

export function getPasswordRouteRedirect(hasToken, userInfo, path) {
    if (!hasToken) return path === PASSWORD_CHANGE_PATH ? '/login' : null;
    if (userInfo?.passwordChangeRequired) {
        return path === PASSWORD_CHANGE_PATH ? null : PASSWORD_CHANGE_PATH;
    }
    if (userInfo && path === PASSWORD_CHANGE_PATH) return '/home';
    return null;
}
